import Vue from 'vue';
import FormatTime from '../filters/FormatTime';
import NiceAmount from '../filters/NiceAmount';
import Currency from '../filters/Currency';
import { EventBus } from '../api/eventbus';

export default class Messages {
    constructor() {
        this.messages = [];
        this.lastID = 0;
        this.registerEvents();
    }

    registerEvents() {
        EventBus.$on('addMessage', message => {
            message = Messages.convertMessageObject(message);
            this.addMessage(message.type, message.text, message.headline, message.dismissible, message.check, message.timeout, message.cb);
        });
        EventBus.$on('clearMessage', message => {
            message = Messages.convertMessageObject(message);
            this.clearMessage(message);
        });
        EventBus.$on('addUpgradeMessage', data => {
            this.addUpgradeMessage(data);
        });
        EventBus.$on('addAchievementMessage', data => {
            this.addAchievementMessage(data);
        });
        EventBus.$on('addEventMessage', data => {
            this.addEventMessage(data);
        });
        EventBus.$on('addLoadSuccessMessage', (seconds, income) => {
            this.addLoadSuccessMessage(seconds, income);
        });
    }

    /**
     * @param message
     * @return {*}
     */
    static convertMessageObject(message) {
        if (!('dismissible' in message)) {
            message.dismissible = false;
        }
        if (!('check' in message)) {
            message.check = false;
        }
        if (!('timeout' in message)) {
            message.timeout = false;
        }
        if (!('cb' in message)) {
            message.cb = null;
        }
        return message;
    }

    /**
     * get all messages
     *
     * @returns {Array}
     */
    getMessages() {
        return this.messages;
    }

    /**
     * add new message to queue
     *
     * @param type
     * @param text
     * @param headline
     * @param dismissible
     * @param check
     * @param time
     * @param cb
     */
    addMessage(type = '', text = '', headline = '', dismissible = true, check = false, time = 3500, cb = null) {
        if (this.lastID > 100) {
            this.last = 0;
        }
        let msg = {
                type,
                text,
                time,
                headline,
                check,
                dismissible,
                id:          `msg-${++this.lastID}`,
                class:       'message',
                timeout:     null,
                pause:       () => {
                    dismissible = true; // just to fool lint
                    // if (msg.timeout !== null && typeof msg.timeout === 'object') {
                    //     this.$timeout.cancel(msg.timeout);
                    // }
                    return false;
                },
                continue:    () => {
                    if (msg.time !== false) {
                        let timeOut = msg.time || 3500;
                        msg.timeout = setTimeout(() => {
                            this.clearMessage(msg);
                        }, timeOut);
                    }
                }
            },
            timeOut;
        if (time !== false) {
            timeOut = time || 3500;
            msg.timeout = setTimeout(() => {
                this.clearMessage(msg);
            }, timeOut);
        }
        this.messages.push(msg);

        return cb !== null && typeof cb === 'function'
            ? cb(msg)
            : msg;
    }

    /**
     * remove message from queue
     *
     * @param message
     * @returns {boolean}
     */
    clearMessage(message) {
        let found = false,
            elem  = document.getElementById(message.id);
        const len = this.messages.length;
        if (elem) {
            elem.className += ' fadeout';
            setTimeout(() => {
                for (let i = 0; i < len; ++i) {
                    if (this.messages[i] === message) {
                        this.messages.splice(i, 1);
                        found = true;
                        break;
                    }
                }
            }, 800);
        }
        return found;
    }

    /**
     * send message after upgrade
     *
     * @param res
     * @returns {boolean}
     */
    addUpgradeMessage(res) {
        let msg,
            head,
            send = false;
        if (typeof res.shop !== 'undefined' && Object.prototype.hasOwnProperty.call(res, 'upgrades')) {
            res.upgrades.forEach(upgrade => {
                if (Object.prototype.hasOwnProperty.call(upgrade, 'type') && Object.prototype.hasOwnProperty.call(upgrade, 'factor')) {
                    send = false;
                    head = `${upgrade.amount} x ${Vue.i18n.translate(upgrade.shop)}`;
                    if (upgrade.type === 'coolDown') {
                        msg = Vue.i18n.translate('SHOP_AUTOUPGRADE_COOLDOWN_MSG', {
                            shopName: Vue.i18n.translate(res.shop.name),
                            factor:   upgrade.factor
                        });
                        send = true;
                    } else if (upgrade.type === 'earnings') {
                        msg = Vue.i18n.translate('SHOP_AUTOUPGRADE_EARNINGS_MSG', {
                            shopName: Vue.i18n.translate(res.shop.name),
                            factor:   upgrade.factor
                        });
                        send = true;
                    }
                    if (send === true) {
                        this.addMessage('success', msg, head, true);
                    }
                }
            });
        }
        return send;
    }

    /**
     * creates a message after successful loading of a gamestate
     *
     * @param secondsGone
     * @param incomeGenerated
     * @returns {boolean}
     */
    addLoadSuccessMessage(secondsGone, incomeGenerated) {
        let msg  = Vue.i18n.translate('INCOMEGENERATEDWHILEGONE', {
                income: NiceAmount(incomeGenerated)
            }),
            head = Vue.i18n.translate('GONEFOR', {
                time: FormatTime(secondsGone)
            });
        this.addMessage('info', msg, head, true);
        return true;
    }

    /**
     * creates a message for new achievements
     *
     * @param res
     * @returns {boolean}
     */
    addAchievementMessage(res) {
        let msg,
            head;
        if (Object.prototype.hasOwnProperty.call(res, 'bonusType')) {
            if (res.bonusType === 'increaseEarnings' && typeof res.bonusFactor === 'number') {
                head = Vue.i18n.translate(res.name);
                msg = Vue.i18n.translate('SHOP_AUTOUPGRADE_EARNINGS_MSG', {
                    shopName: Vue.i18n.translate('allShops'),
                    factor:   res.bonusFactor
                });
                this.addMessage('success', msg, head, true);
            }
        }
        return true;
    }

    /**
     * creates a message for random events
     *
     * @param event
     */
    addEventMessage(event) {
        let head,
            msgBody;
        if (typeof event.shop !== 'undefined') {
            if (!Object.prototype.hasOwnProperty.call(event, 'singleCost')) {
                event.singleCost = 0;
            }
            if (typeof event.cost === 'object') {
                event.cost = event.cost.toString();
            }
            if (typeof event.singleCost === 'object') {
                event.singleCost = event.singleCost.toString();
            }
            head = event.isGood === true ? Vue.i18n.translate('UPGRADE_POSITIVE') : Vue.i18n.translate('UPGRADE_NEGATIVE');
            msgBody = `<p class="event-name">${Vue.i18n.translate(event.name, {
                shop:       Vue.i18n.translate(event.shop),
                singleCost: Currency(event.singleCost),
                cost:       NiceAmount(event.cost)
            })}</p>`;
            msgBody += '<p class="event-meta">';
            switch (event.bonusType) {
            case 'increaseEarnings':
            case 'decreaseEarnings':
                msgBody += `${Vue.i18n.translate('EARNINGSFOR')} ${Vue.i18n.translate(event.shop)} * ${event.bonusFactor}`;
                break;
            case 'decreaseBalance':
                msgBody += `&#45;${NiceAmount(event.cost)}`;
                break;
            case 'increaseBalance':
                msgBody += `+ ${NiceAmount(event.cost)}`;
                break;
            case 'modifyProductionTime':
                msgBody += Vue.i18n.translate('productionTime');
                if (event.shop !== null) {
                    msgBody += ` ${Vue.i18n.translate('FOR_SHOP', { shop: Vue.i18n.translate(event.shop) })}`;
                }
                msgBody += event.bonusFactor < 1
                    ? ` * ${Math.floor(1 / event.bonusFactor * 100) / 100}`
                    : ` / ${event.bonusFactor}`;

                break;
            case 'strike':
                msgBody += Vue.i18n.translate('ON_STRIKE_FOR', { duration: Math.floor(event.duration / 1000) });
            }
            msgBody += '</p>';
            this.addMessage(event.isGood ? 'info' : 'danger', msgBody, head, true, false, 10000);
        }
    }
}
